export default function BookmarkIcon({
  className,
  fill = false,
}: {
  className?: string;
  fill?: boolean;
}) {
  if (fill) {
    return (
      <svg
        className={className}
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M13.25 3.875H6.25C5.98478 3.875 5.73043 3.98457 5.54289 4.17961C5.35536 4.37466 5.25 4.63919 5.25 4.91502V16.3552C5.25004 16.4481 5.27397 16.5392 5.31929 16.6191C5.3646 16.699 5.42967 16.7649 5.50772 16.8099C5.58578 16.8548 5.67399 16.8773 5.76319 16.8748C5.85239 16.8724 5.93933 16.8451 6.015 16.796L9.75 14.3682L13.4856 16.796C13.5613 16.845 13.6482 16.8721 13.7373 16.8744C13.8264 16.8768 13.9145 16.8543 13.9924 16.8094C14.0704 16.7644 14.1354 16.6986 14.1807 16.6188C14.2259 16.5389 14.2499 16.448 14.25 16.3552V4.91502C14.25 4.63919 14.1446 4.37466 13.9571 4.17961C13.7696 3.98457 13.5152 3.875 13.25 3.875Z" />
      </svg>
    );
  }
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M13.25 3.875H6.25C5.98478 3.875 5.73043 3.98457 5.54289 4.17961C5.35536 4.37466 5.25 4.63919 5.25 4.91502V16.3552C5.25004 16.4481 5.27397 16.5392 5.31929 16.6191C5.3646 16.699 5.42967 16.7649 5.50772 16.8099C5.58578 16.8548 5.67399 16.8773 5.76319 16.8748C5.85239 16.8724 5.93933 16.8451 6.015 16.796L9.75 14.3682L13.4856 16.796C13.5613 16.845 13.6482 16.8721 13.7373 16.8744C13.8264 16.8768 13.9145 16.8543 13.9924 16.8094C14.0704 16.7644 14.1354 16.6986 14.1807 16.6188C14.2259 16.5389 14.2499 16.448 14.25 16.3552V4.91502C14.25 4.63919 14.1446 4.37466 13.9571 4.17961C13.7696 3.98457 13.5152 3.875 13.25 3.875ZM13.25 15.4173L10.0144 13.3145C9.93491 13.2628 9.84308 13.2354 9.74937 13.2354C9.65566 13.2354 9.56384 13.2628 9.48438 13.3145L6.25 15.4173V4.91502H13.25V15.4173Z" />
    </svg>
  );
}
